import React, { useEffect, useState } from "react";
import { Theme } from "../../core/Models/CustomSiteConfigModel";
import { Parameters } from "../../core/Models/CustomSiteConfigModel";
import { themeService } from "../../core/NotificationStripNav/ThemeService";
import { parametersService } from "../../core/NotificationStripNav/ParametersService";
import { ReactComponent as AudiomoversLogo } from "../../../assets/images/audiomovers-logo.svg";
import { useNavigate } from "react-router-dom";

import "./NotFound.css";

const NotFound: React.FC = () => {
  const [theme, setTheme] = useState<Theme | null>(themeService.getTheme());
  const [parameters, setParameters] = useState<Parameters | null>(
    parametersService.getParameters()
  );
  const navigate = useNavigate();

  const handleClick = (
    link: string | undefined,
    linkType: string | undefined
  ) => {
    if (link) {
      if (linkType === "story") {
        navigate(`/${link}`);
      } else {
        const url = new URL(link, window.location.origin);
        window.location.href = url.href;
      }
    }
  };

  useEffect(() => {
    const parametersServiceUnsubscribe =
      parametersService.subscribe(setParameters);
    const themeServiceUnsubscribe = themeService.subscribe(setTheme);
    return () => {
      parametersServiceUnsubscribe();
      themeServiceUnsubscribe();
    };
  }, []);

  return (
    <div className="not-found" style={{ backgroundColor: theme?.panelColour }}>
      <div className="not-found-container" style={{ color: theme?.textColor }}>
        <div className="logo">
          <a href="/">
            <AudiomoversLogo fill={theme?.textColor}></AudiomoversLogo>
          </a>
        </div>
        <div className="title" style={{ color: theme?.textColor }}>
          404 page not found
        </div>
        <div className="stand-first" style={{ color: theme?.textColor }}>
          THE PAGE YOU WERE LOOKING FOR DOES NOT EXIST
        </div>
        <div className="action-home">
          <div className="button-container">
            <a href="/" className="button" style={{ color: theme?.textColor }}>
              GO HOME
            </a>
          </div>
        </div>
        <div className="action-visit" style={{ color: theme?.textColor }}>
          OR VISIT THE LINKS BELOW
        </div>
        <div className="action-links">
          <div
            className="action-link"
            style={{
              color: theme?.textColor,
              backgroundColor: theme?.containerColor,
            }}
            onClick={() =>
              handleClick(
                parameters?.supportLink?.cached_url || "/support/get-help",
                parameters?.supportLink?.cached_url
                  ? parameters?.supportLink?.linktype
                  : undefined
              )
            }
          >
            SUPPORT
          </div>
          <div
            className="action-link"
            style={{
              color: theme?.textColor,
              backgroundColor: theme?.containerColor,
            }}
            onClick={() =>
              handleClick(
                parameters?.newsLink?.cached_url || "/news",
                parameters?.newsLink?.cached_url
                  ? parameters?.newsLink?.linktype
                  : undefined
              )
            }
          >
            NEWS
          </div>
          <div
            className="action-link"
            style={{
              color: theme?.textColor,
              backgroundColor: theme?.containerColor,
            }}
            onClick={() =>
              handleClick(
                parameters?.productsLink?.cached_url || "/products/listento",
                parameters?.productsLink?.cached_url
                  ? parameters?.productsLink?.linktype
                  : undefined
              )
            }
          >
            PRODUCTS
          </div>
          <div
            className="action-link"
            style={{
              color: theme?.textColor,
              backgroundColor: theme?.containerColor,
            }}
            onClick={() =>
              handleClick(
                parameters?.downloadsLink?.cached_url || "/downloads",
                parameters?.downloadsLink?.cached_url
                  ? parameters?.downloadsLink?.linktype
                  : undefined
              )
            }
          >
            DOWNLOADS
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
